<template>
  <tr>
    <td class="fw-bold">
      <div class="text-dark fw-bolder text-hover-primary mb-1 fs-6">
        <span :class="paymentTypeClasses">{{ this.Name }}</span>
      </div>
    </td>
    <td>
      {{ this.amount }}
    </td>
    <td class="text-end">
      <div class="text-dark fw-bolder text-hover-primary mb-1 fs-6">
         <button v-if="showCopyLink" class="btn btn-primary" @click="copyPaymentLink">Copy Link</button>
         <a v-if="showPayNow" :href="PaymentLink" class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6">Pay</a>
      </div>
    </td>
    <StackingNotification
      v-if="notifications.length > 0"
      :stackNotifications="notifications"
      @eClose="removeNotification"
      @eClearAll="clearAllNotification"
    />
  </tr>
</template>

<script>
import { formatCurrency } from "@/mixins/shared";
import StackingNotification from "@/components/StackingNotification.vue";
import StackingNotificationMixins from "@/mixins/StackingNotificationMixins";
import mixins from "vue-typed-mixins";

export default mixins(StackingNotificationMixins).extend({
  name:"OutstandingPaymentRecord",
  props: {
    Amount: {
      type: Number,
      required: true,
    },
    Name: {
      type: String,
      required: true,
    },
    PaymentLink: {
      type: String,
      required: true
    },
    showCopyLinkButton: {
      type: Boolean,
      default: false
    },
    showPayNowButton: {
      type: Boolean,
      default: false
    },
  },
  components: {StackingNotification},
  data() {
    return {

    };
  },
  computed: {
    amount() {
      return formatCurrency(this.Amount);
    },
    paymentTypeClasses() {
      return "badge badge-light-warning";
    },
    showCopyLink() {
      return this.showCopyLinkButton && !!this.PaymentLink
    },
    showPayNow(){
      return this.showPayNowButton && !!this.PaymentLink
    }
  },
  methods: {
    copyPaymentLink(){
      navigator.clipboard.writeText(this.PaymentLink);
        this.addNotification({
          message: `Payment Link Copied To Clipboard`
        });
    }
  },
});
</script>

<style scoped></style>
